import { Grid, Input, InputLabel, InputAdornment, Box, Button } from "@material-ui/core";
import React, { ChangeEvent, useState } from "react";
import "./login-form.scss";
import Envelope from "../../../../assets/images/png/envelope.png";
import Vector from "../../../../assets/images/png/Vector.png";
import AuthenticationApi from "../../../../services/authentication-api";
import { Redirect } from "react-router-dom";
import i18next from "i18next";
import axios, { AxiosError } from "axios";

type LoginFormProps = {
    spFull: string;
    authType: string;
    acs: string;
};

const LoginForm = ({ spFull, authType, acs }: LoginFormProps): React.ReactElement => {
    const [formError, setFormError] = useState<string | undefined>(undefined);

    const [state, setState] = useState({
        formCredentials: {
            email: "",
            password: "",
            sp: spFull,
        },
        redirectToSelectOffice: false,
        oso: [] as string[][],
        sessionId: "",
        pi2AuthToken: "",
        token: "",
    });

    const handleError = (error?: Error | AxiosError): void => {
        if (axios.isAxiosError(error)) {
            if (error.response?.status === 403) {
                setFormError("Bad credentials");
                return;
            }
        }
        setFormError("Unknow error");
    };
    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const authenticationApi = new AuthenticationApi();
        authenticationApi
            .authenticateWithForm(state.formCredentials)
            .then((response) => {
                const hasToRedirectToSelectOffice = response.officesSubOffices.length > 1;
                const hasToRedirectToAcs = response.officesSubOffices.length === 1;
                const account = response.officesSubOffices[0];
                let token = "";

                if (hasToRedirectToAcs) {
                    authenticationApi
                        .selectOfficeSubOffice({
                            office: account[0],
                            subOffice: account[1],
                            acs,
                            issuer: spFull,
                            pi2AuthToken: response.pi2AuthToken,
                            sessionId: response.sessionId,
                        })
                        .then((responseFromSelectOffice) => {
                            if (responseFromSelectOffice.status === "success") {
                                token = responseFromSelectOffice.artifact;
                                authenticationApi.autoPost({
                                    acs,
                                    sp: spFull,
                                    token: responseFromSelectOffice.artifact,
                                });
                            } else {
                                handleError();
                                console.error("An error occured during the selection of offices");
                            }
                        })
                        .catch((error) => {
                            handleError(error);
                        });
                }

                setState({
                    ...state,
                    redirectToSelectOffice: hasToRedirectToSelectOffice,
                    oso: response.officesSubOffices,
                    sessionId: response.sessionId,
                    pi2AuthToken: response.pi2AuthToken,
                    token,
                });
            })
            .catch((error) => {
                handleError(error);
            });
    };

    const handleChangeEmail = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        e.preventDefault();
        setFormError(undefined);
        const value = e.currentTarget === null ? "" : e.currentTarget.value;
        setState({
            ...state,
            formCredentials: {
                ...state.formCredentials,
                email: value,
            },
        });
    };

    const redirectToSelectOffice = () => {
        const { oso, sessionId, pi2AuthToken } = state;
        return (
            <Redirect
                to={{
                    pathname: `/select-office`,
                    state: {
                        oso,
                        authType,
                        spFull,
                        acs,
                        sessionId,
                        pi2AuthToken,
                    },
                }}
            />
        );
    };

    const handleChangePassword = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const value = e.currentTarget === null ? "" : e.currentTarget.value;
        setFormError(undefined);
        setState({
            ...state,
            formCredentials: {
                ...state.formCredentials,
                password: value,
            },
        });
    };

    if (state.redirectToSelectOffice) {
        return redirectToSelectOffice();
    }

    return (
        <Box>
            <Grid container>
                <Grid item xs>
                    <form onSubmit={handleSubmit} noValidate>
                        <InputLabel htmlFor="login-form-email" className="input-outside-label">
                            {i18next.t("LoginPage.LoginForm.LabelEmail")}
                        </InputLabel>
                        <Input
                            id="login-form-email"
                            className="custom-login-form input-inside-label"
                            required
                            placeholder={i18next.t("LoginPage.LoginForm.Email")}
                            startAdornment={
                                <InputAdornment position="start">
                                    <img className="input-icon" src={Envelope} alt="envelope" />
                                </InputAdornment>
                            }
                            value={state.formCredentials.email}
                            onChange={handleChangeEmail}
                            disableUnderline
                        />
                        <div className="div-spacer" />
                        <InputLabel htmlFor="login-form-password" className="input-outside-label">
                            {i18next.t("LoginPage.LoginForm.LabelPassword")}
                        </InputLabel>
                        <Input
                            id="login-form-password"
                            type="password"
                            className="custom-login-form input-inside-label"
                            required
                            placeholder={i18next.t("LoginPage.LoginForm.Password")}
                            startAdornment={
                                <InputAdornment position="start">
                                    <img className="input-icon" src={Vector} alt="lock" />
                                </InputAdornment>
                            }
                            disableUnderline
                            value={state.formCredentials.password}
                            onChange={handleChangePassword}
                        />
                        <div className="error">{formError}</div>
                        <Button variant="contained" className="btn btn-submit" id="btn-submit" type="submit">
                            {i18next.t("LoginPage.LoginForm.Submit")}
                        </Button>
                        <div className="div-spacer" />
                    </form>
                </Grid>
            </Grid>
        </Box>
    );
};

export default LoginForm;
